<template>
    <div :id="id" v-show="!filtered" v-if="resetAnimation" :class="[{activeTlItem: curr_selected, unviewed: !viewed && !preview}, style]" :style="edit ? '' : 'margin: 0.2em 0.2em 0.3em 0.2em;' + ghost_preview" @mouseover="onMouseOver" @mouseleave="onMouseLeave" @click.self="showPreview">
        <div class="contentLeft" v-if="edit" @click.self="showPreview">
            <div class="tlItemMiddle" @click="showPreview">
                <i :class="icon" style="margin-top: 0.3em" />
                <div style="overflow: hidden; text-overflow: ellipsis; margin-top: 0.2em;">{{label}}</div>
                <div v-if="curr_published && game_running && hover && time_since_publish" :style="{ visibility: edit && hover ? 'visible' : 'hidden', 'margin-right': is_alert && show_alert_countdown ? '0.5em' : null}" class="timeSincePublish">{{time_since_publish}}</div>
                <div v-if="is_alert" v-show="curr_published && show_alert_countdown" class="tlItemRight" style="min-height: 1.6em; padding-top: 0.15em;" :style="{'margin-left': hover ? null : 'auto'}">
                    <VueCountdown :time="alert_countdown_time" :autoStart="true" :transform="transform" @end="alert_countdown_time = 0" ref="countdown">
                        <template v-slot="props">
                            <span style="font-size: 1.1em;">{{ props.minutes }}:{{ props.seconds }}</span>
                        </template>
                    </VueCountdown>
                </div>
            </div>

            <div v-if="!is_event" class="tlItemRight" @click.self="showPreview" style="min-height: 1.6em;">
                <div v-for="group in pgroups" :key="group.pgroup_id" @click="selectGroup(group.pgroup_id)" style="margin-top: 0.2em;"> 
                    <span class="fa-layers fa-fw">
                        <i v-if="selected_groups.includes(group.pgroup_id)" class="fas fa-circle" :style="'margin:0; margin-left: 0.2em; font-size:1.3em; color:' + getGroupColor(group.pgroup_id)" />
                        <i v-else class="far fa-circle" :style="'margin:0; margin-left: 0.2em; font-size:1.3em; color:' + getGroupColor(group.pgroup_id)" />                    
                    </span>
                </div>
            </div>
            <div v-else-if="is_event && curr_published" class="tlItemRight" style="padding-right: 4em; min-height: 1.6em; padding-top: 0.15em;">
                <VueCountdown v-show="show_event_countdown" :time="event_countdown_time" :autoStart="!evt_paused" :transform="transform" ref="countdown">
                    <template v-slot="props">
                        <span style="font-size: 1.1em;">{{ props.minutes }}:{{ props.seconds }}</span>
                    </template>
                </VueCountdown>
            </div>
            <div v-else class="tlItemRight" @click.self="showPreview" style="min-height: 1.6em;" />
        </div>

        <div class="contentLeft" v-else @click="showPreview">
            <div class="tlItemLeft">
                <i :class="icon" style="margin-top: 0.3em" />
            </div>
            <div class="tlItemMiddle">
                <div style="overflow: hidden; text-overflow: ellipsis; margin-top: 0.2em;">{{label}}</div>
                <div v-if="game_running && hover && !preview" class="timeSincePublish">{{time_since_publish}}</div>
            </div>
        </div>

        <div class="contentRight" @click.self="showPreview" v-if="edit" :style="{ visibility: edit && hover ? 'visible' : 'hidden' }">

            <div v-if="(is_event || content_type == 'reactive_audio') && !has_recipients" style="margin-top: 0.15em; margin-right: 0.1em; color: #ed5338; visibility: visible" class="tlItemRight">
                <i class="fas fa-user-slash" />
            </div>

            <div @click="forcePreview" v-if="curr_published && game_running && previewable_ct" class="tlItemRight button">
                <i class="fas fa-eye" />
            </div>
            <div @click="showContentLb" title="Redigér" v-if="!(game_running && curr_published && is_event)" class="tlItemRight button">
                <i class="fas fa-edit" />
            </div>
            <div @click="checkContent" title="Publicér" v-if="!curr_published && game_running" class="tlItemRight button">
                <i class="fas fa-sign-in-alt" />
            </div>
            <div @click="unpublishContent(content_id)" title="Afpublicér" v-if="curr_published && game_running && !show_event_countdown" class="tlItemRight button">
                <i class="fas fa-undo-alt" />
            </div>

            <div @click="resumeEvent" v-if="is_active_event && evt_paused && show_event_countdown" class="tlItemRight button">
                <i class="fas fa-play" />
            </div>
            <div @click="pauseEvent" v-if="is_active_event && evt_ongoing && show_event_countdown" class="tlItemRight button">
                <i class="fas fa-pause" />
            </div>
            <div @click="stopEvent" v-if="is_active_event && launched_event && !launched_event.ended && show_event_countdown" class="tlItemRight button" >
                <i class="fas fa-stop" />
            </div>

            <div class="tlItemRight dragHandle">
                <i class="fas fa-grip-lines" />
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import {transform} from '../global/countdown_transform';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

const CLASS = {
    'article': 'tlItemStandard',
    'image': 'tlItemStandard',
    'video': 'tlItemStandard',
    'audio': 'tlItemStandard',
    'reactive_video': 'tlItemStandard',
    'reactive_audio': 'tlItemStandard',
    'call_event': 'tlItemAction',
    'sms_event': 'tlItemAction',
    'post_event': 'tlItemAction',
    'newsbanner': 'tlItemAction',
    'instruction': 'tlItemAction'
}

const ICON = {
    'article': 'fa-newspaper',
    'image': 'fa-image',
    'video': 'fa-video',
    'audio': 'fa-volume-up',
    'reactive_audio': 'fa-microphone',
    'reactive_video': 'fa-film',
    'call_event': 'fa-phone',
    'sms_event': 'fa-comments',
    'post_event': 'fa-hashtag',
    'newsbanner': 'fa-bullhorn',
    'instruction': 'fa-exclamation-triangle'
}

export default {
    name: 'Content',
    components: {
        VueCountdown: () => import('@chenfengyuan/vue-countdown')
    },
    props: {
        section_id: Number,
        content_id: Number,
        content_type: String,
        label: String,
        published: Boolean,
        edit: Boolean,
        time_offset: Number,
        auto_publish: Boolean,
        publish_time_ts: Number,
        pgroup_id: Number,
        index: Number,
        preview: Boolean
    },
    data() {
        return {
            id: 'content-' + this.content_id,
            icon: "fas " + ICON[this.content_type],
            hover: false,
            time_input: this.time_offset,
            previewable_ct: CLASS[this.content_type] != 'tlItemAction' && this.content_type != 'reactive_audio',
            focus: false,
            resetAnimation: true,

            // Events
            is_event: ['call_event', 'sms_event', 'post_event'].includes(this.content_type),
            is_alert: this.content_type == 'instruction' || this.content_type == 'newsbanner',
            alert_countdown_time: 0
        }
    },
    watch: {
        event_countdown_time(new_val, old_val) {
            if (old_val > 0 && new_val == 0)
                this.$refs.countdown.abort()
        }
    },
    computed: {
        ...mapGetters([
            'getLaunchedEvent',
            'getGroupColor',
            'getContentGroups',
            'getParticipantGroup',
            'getCurrPreview',
            'getContent',
            'getAllContent'
        ]),
        ...mapGetters({
            pgroups: 'getParticipantGroups',
            pgroup_filter: 'getParticipantGroupFilter'
        }),
        ...mapState([
            'game_running',
            'curr_preview',
            'curr_instance',
            'curr_project'
        ]),
        launched_event() {
            return this.getLaunchedEvent(this.content_id)
        },
        event_countdown_time() {
            if (this.launched_event && this.launched_event.ended) return 0
            if (this.is_event && this.launched_event) {
                if (this.evt_paused) return dayjs(this.launched_event.end_time).diff(dayjs(this.launched_event.pause_time), 'ms')
                const remaining = dayjs(this.launched_event.end_time).diff(dayjs(),'ms')
                if (remaining > 0) return remaining
            }
            return 0
        },
        evt_ongoing() {
            if (this.is_event && this.launched_event && !this.launched_event.ended && !this.launched_event.pause_time) return true
            return false
        },
        evt_paused() {
            if (this.is_event && this.launched_event && this.launched_event.pause_time) return true
            return false
        },
        show_event_countdown() {
            return this.event_countdown_time != 0
        },
        show_alert_countdown() {
            return this.alert_countdown_time != 0
        },
        ghost_preview() {
            if (this.curr_selected && this.style === 'ghost') return "border: 0px;"
            return ""
        },
        selected_groups: {
            get() {
                return this.getContentGroups(this.content_id)
            },
            set(pgroups) {
                this.setContentAttr({content_id: this.content_id, attr: 'pgroups', val: pgroups});
            }
        },
        style() {
            return this.curr_published && this.game_running ? "ghost" : CLASS[this.content_type]
        },
        is_active_event() {
            return this.is_event && (this.curr_published && this.game_running)
        },
        curr_selected() {
            if (this.preview) return this.getParticipantGroup(this.pgroup_id).curr_preview == this.content_id
            return this.getCurrPreview == this.content_id
        },
        viewed() {
            if (this.$parent.$options.name == 'Participant' && !this.preview) {
                return this.$parent.viewed.includes(this.content_id)
            }
            return true
        },
        curr_auto_publish() {
           return this.getContent(this.content_id).auto_publish
        },
        filtered() {
            return this.edit && this.selected_groups.length > 0 && this.pgroups.length > 0 && !this.is_event ? !this.selected_groups.some(g => !this.pgroup_filter.includes(g)) : false
        },
        has_recipients() {
            return this.getContent(this.content_id).has_recipients
        },
        curr_published: {
            get() {return this.edit? this.getContent(this.content_id).published: false},
            set: function(published) { this.setContentAttr({content_id: this.content_id, attr: 'published', val: published})}
        },
        time_since_publish() {
            if (this.$parent.$options.name == 'Participant')
                return dayjs.unix(this.publish_time_ts).format('HH:mm')
            else
                return dayjs().from(dayjs.unix(this.publish_time_ts), true)
        }
        
    },
    mounted() {
        dayjs.extend(relativeTime)
        if (this.is_alert && this.curr_published) {
            axios.get('/api/content/' + this.content_id).then((response) => {
                if (response.data.duration) this.alert_countdown_time = dayjs.unix(this.publish_time_ts).add(response.data.duration, 's').diff(dayjs(), 'ms')
            })
        }
    },
    updated() {
        if (this.focus) {
            this.$refs.timeInput.focus()
        }
    },
    methods: {
        ...mapActions([
            'fetchLaunchedEvents',
            'refreshSections',
        ]),
        ...mapMutations([
            'setContent',
            'setContentAttr',
            'setLaunchedEventAttr'
        ]),
        forcePreview() {
            this.$socket.emit("forcePreview", {
                content_id: this.content_id,
                pgroups: this.selected_groups
            })
        },
        playerForcePreview() {
            this.$emit('playerForcePreview', this)
        },
        showPreview() {
            if (CLASS[this.content_type] != 'tlItemAction' && this.content_type != 'reactive_audio') {
                this.$emit('showPreview', this.content_id)
            }
        },
        showContentLb() {
            this.$emit("showContentLb", this.content_id, this.content_type, this.time_offset, this.auto_publish, this.index)
        },
        onMouseOver() { this.hover = true },
        onMouseLeave() { this.hover = false },
        selectGroup(group) {
            const pgroups = this.selected_groups.map(x => x)
            const index = pgroups.indexOf(group)
            const selected = index == -1

            if (!selected) pgroups.splice(index, 1)
            else pgroups.push(group)
            axios.put('/api/content/' + this.content_id + '?groups_only=true', {groups: pgroups}).then(() => {
                const data = {content_id: this.content_id, pgroups: [group], instance_id: this.curr_instance, group_only: true}
                if (!selected) this.$socket.emit('removeContent', data)
                else if (this.curr_published) this.$socket.emit('pushContent', data)
                this.selected_groups = pgroups
            })
        },
        textColor(group) {
            if (this.selected_groups.includes(group)) return 'white'
            else if (CLASS[this.content_type] == 'tlItemAction') return '#E86D00'
            else return 'black'
        },
        checkEvent() {
            if (!this.has_recipients)
                this.$modal.show('dialog', {
                    text: 'Vælg venligst nogle modtagere',
                    buttons: [{ title: 'Ok', handler: () => this.$modal.hide('dialog') }]
                })
            else {
                this.publishContent(this.content_id)
                this.startEvent()
            }
        },
        checkReactiveAudio() {
            axios.get('/api/content/' + this.content_id).then(response => {
                if (!response.data.recipient_id) {
                    this.$modal.show('dialog', {
                        text: 'Vælg venligst en modtager',
                        buttons: [{ title: 'Ok', handler: () => this.$modal.hide('dialog') }]
                    })
                }
                else  {
                    this.publishContent(this.content_id)
                    axios.post("/twilio/reactive_audio/" + this.content_id)
                }
            })
        },
        checkContent() {
            if (this.content_type === 'reactive_audio') this.checkReactiveAudio()
            else if (['call_event', 'sms_event', 'post_event'].includes(this.content_type)) this.checkEvent()
            else this.publishContent(this.content_id)
        },
        publishContent(content_id) {
            if (this.content_type == "instruction") {
                const prev_instr = this.getAllContent.find(c => c.content_type == 'instruction' && c.published == true)
                if (prev_instr) this.unpublishContent(prev_instr.content_id)
            }
            axios.put('/api/content/' + content_id + '?publish_only=true', {published: true}).then((response) => {
                this.setContent(response.data)
                if (this.content_type == 'instruction' || this.content_type == 'newsbanner') {
                    if (response.data.duration) this.alert_countdown_time = response.data.duration * 1000
                }
            })

            if (!this.is_event && this.content_type != 'reactive_audio') {
                const data = {content_id: content_id, pgroups: this.selected_groups, instance_id: this.curr_instance}
                this.$socket.emit('pushContent', data)
            }
        },
        unpublishContent(content_id) {
            axios.put('/api/content/' + content_id + '?publish_only=true', {published: false}).then((response) => {
                this.setContent(response.data)
            })
            if (!this.is_event) {
                this.$socket.emit('removeContent', {
                    content_id,
                    pgroups: this.selected_groups,
                    instance_id: this.curr_instance,
                    group_only: false
                })
                if (this.content_type == 'instruction' || this.content_type == 'newsbanner') {
                   this.alert_countdown_time = 0
                }
            }
        },
        // Events
        startEvent() {
            axios.post("/events/" + this.content_id + "/start").then(() => this.fetchLaunchedEvents())
        },
        resumeEvent() {
            this.$refs.countdown.counting = true
            this.$refs.countdown.continue()
            axios.post('/events/' + this.content_id + '/resume').then(() => {
                this.fetchLaunchedEvents()
            })
        },
        pauseEvent() {
            this.$refs.countdown.counting = false
            this.$refs.countdown.pause()
            axios.post('/events/' + this.content_id + '/pause').then(() => {
                this.fetchLaunchedEvents()
            })
        },
        stopEvent() {
            this.$refs.countdown.abort()
            axios.post('/events/' + this.content_id + '/stop').then(() => {
                this.setLaunchedEventAttr({
                    content_id: this.content_id,
                    attr: 'ended',
                    val: true
                })
            })
        },
        transform(props) {
            return transform(props)
        },
        formatTimeOffset() {
           return this.time_offset < 10 ? `0${this.time_offset}` : this.time_offset
        },
        contentTimePublished() {
            // Check if this content is viewed by participant
            if(this.$parent.$options.name == 'Participant'){
                this.time_since_publish = dayjs.unix(this.publish_time_ts).format('HH:mm')
            }else {
                this.time_since_publish = dayjs().from(dayjs.unix(this.publish_time_ts), true)
            }
        }
    }
}
</script>

<style>

.timeSincePublish {
    white-space: nowrap;
    margin-top: 0.2em;
    margin-left: auto;
    margin-right: 0.2em;
    opacity:0.6;
}

.unviewed {
    animation: blink 2s linear infinite;
}

#editTime {
    border-radius: 0.5em; 
    text-align: center;
    display: flex;
}

#editTime:hover {
    background-color: #d7d7d7;
    cursor: text;
}

.inputTime {
    width: 1.5em;
    background: transparent;
    border: none;
    font-size: 1em;
    text-align: right;
}

.dragHandle {
    visibility: visible;
    margin-top: 0.1em;
}

.contentLeft {
    display: flex;
    flex: 1 1 auto;
    width: calc(100% - 5.2em); /* Needed for ellipsis, the -5.2em is to make room for contentRight */
}

.contentMiddle {
    display: flex;
    margin-top: 0.2em;
}

.contentRight {
    display: flex;
    justify-content: flex-end;
    width: 5.2em;
}

.contentRight > .tlItemRight.button {
    margin-right: 0.6em; 
    margin-top: 0.1em;
}

.contentRight > .tlItemRight.button:last-of-type {
    margin-right: 0;
}

.contentRight > .tlItemRight.button > .fas, 
.contentRight > .tlItemRight.button > .fa {
	margin-left: 0em;
	margin-right: 0em;
}

@keyframes blink{
    0% { 
        background-color: #ff9900; 
        color: #FFF;
    }
    49% { 
        background-color: #ff9900; 
        color: #FFF;
    }
    50% { 
        background-color: #FFF;
        color: #000;
    }
    100% { 
        background-color: #FFF;
        color: #000;
    }
}

</style>